var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3338_29025)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4688 0.363281C5.85202 0.363281 0.46875 5.74655 0.46875 12.3633C0.46875 18.98 5.85202 24.3633 12.4688 24.3633C19.0855 24.3633 24.4688 18.98 24.4688 12.3633C24.4688 5.74655 19.0855 0.363281 12.4688 0.363281ZM16.8136 15.4031C16.9029 15.488 16.9743 15.5898 17.0236 15.7027C17.073 15.8156 17.0992 15.9373 17.1008 16.0605C17.1023 16.1837 17.0792 16.306 17.0328 16.4201C16.9864 16.5342 16.9176 16.6379 16.8305 16.725C16.7434 16.8121 16.6397 16.8809 16.5255 16.9274C16.4114 16.9738 16.2891 16.9969 16.166 16.9953C16.0428 16.9937 15.9211 16.9675 15.8082 16.9182C15.6953 16.8688 15.5934 16.7974 15.5086 16.7081L12.4688 13.6689L9.42894 16.7081C9.25442 16.8739 9.02204 16.965 8.78134 16.9619C8.54063 16.9588 8.31066 16.8618 8.14044 16.6916C7.97022 16.5214 7.87323 16.2914 7.87015 16.0507C7.86707 15.81 7.95814 15.5776 8.12394 15.4031L11.1632 12.3633L8.12394 9.32347C7.95814 9.14895 7.86707 8.91657 7.87015 8.67587C7.87323 8.43516 7.97022 8.20519 8.14044 8.03497C8.31066 7.86475 8.54063 7.76777 8.78134 7.76468C9.02204 7.7616 9.25442 7.85267 9.42894 8.01847L12.4688 11.0577L15.5086 8.01847C15.6831 7.85267 15.9155 7.7616 16.1562 7.76468C16.3969 7.76777 16.6268 7.86475 16.7971 8.03497C16.9673 8.20519 17.0643 8.43516 17.0673 8.67587C17.0704 8.91657 16.9794 9.14895 16.8136 9.32347L13.7743 12.3633L16.8136 15.4031Z",
    fill: "#B54708"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3338_29025"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.46875 0.363281)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCircle);
export default __webpack_public_path__ + "static/media/close-circle.e5dd37b43cc61cc827f58675706e24b3.svg";
export { ForwardRef as ReactComponent };